"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.getAddExpectContinuePlugin = exports.addExpectContinueMiddlewareOptions = exports.addExpectContinueMiddleware = void 0;

var tslib_1 = require("tslib");

var protocol_http_1 = require("@aws-sdk/protocol-http");

function addExpectContinueMiddleware(options) {
  var _this = this;

  return function (next) {
    return function (args) {
      return tslib_1.__awaiter(_this, void 0, void 0, function () {
        var request;
        return tslib_1.__generator(this, function (_a) {
          request = args.request;

          if (protocol_http_1.HttpRequest.isInstance(request) && request.body && options.runtime === "node") {
            request.headers = tslib_1.__assign(tslib_1.__assign({}, request.headers), {
              Expect: "100-continue"
            });
          }

          return [2
          /*return*/
          , next(tslib_1.__assign(tslib_1.__assign({}, args), {
            request: request
          }))];
        });
      });
    };
  };
}

exports.addExpectContinueMiddleware = addExpectContinueMiddleware;
exports.addExpectContinueMiddlewareOptions = {
  step: "build",
  tags: ["SET_EXPECT_HEADER", "EXPECT_HEADER"],
  name: "addExpectContinueMiddleware"
};

exports.getAddExpectContinuePlugin = function (options) {
  return {
    applyToStack: function applyToStack(clientStack) {
      clientStack.add(addExpectContinueMiddleware(options), exports.addExpectContinueMiddlewareOptions);
    }
  };
};